import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
import { Icon } from '../Icon';
import styles from './index.module.less';
export const SelectableIcon = ({ className, selected, children, ...rest }) => {
    return (_jsxs("span", { role: "button", className: classnames(className, styles.container), ...rest, children: [children, selected && _jsx(Icon, { className: styles.icon, type: "checked", size: 16 })] }));
};
